import { useSelector } from 'react-redux';
import ActivityForm from './ActivityForm';
//
// Компонент для создания мероприятия
//
const ActivityEdit = () => {
    const activity = useSelector(state => state.activity);
    const exhibitor = useSelector(state => state.exhibitor);
    return (
		<ActivityForm exhibitor={exhibitor} activity={activity}/>
	);
};

export default ActivityEdit;
